module.exports = __webpack_public_path__ + "img/img-enfj.524dba2d.jpg";